var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ mobile: _vm.isMobile }, 'home-header']},[_c('ExploreToggle',{key:"header",ref:"ExploreToggle",attrs:{"id":"explore-toggle"},on:{"setupExplore":function($event){return _vm.setupExplore()}}}),_c('div',{attrs:{"id":"desktop-spacer"}}),_c('RadioPlayer',{ref:"RadioPlayer",attrs:{"id":"radio-player"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }